module.exports = __webpack_public_path__ + "static/media/relay_spending_burndown.21a9bbeb.png";